const MAX_CLIENT_USER_AGENT_LENGTH = 512;

/**
 * Reads navigator.userAgent at GPS evidence capture time.
 * Returns null when unavailable or empty; caps length for server storage.
 */
export function readClientUserAgentAtCapture(): string | null {
  try {
    const userAgent = navigator?.userAgent?.trim();
    if (!userAgent) {
      return null;
    }
    return userAgent.length <= MAX_CLIENT_USER_AGENT_LENGTH
      ? userAgent
      : userAgent.slice(0, MAX_CLIENT_USER_AGENT_LENGTH);
  } catch {
    return null;
  }
}
